<!--
  A table: a rounded frame with a header row across the top and two column
  lines below it. It is drawn in outline, like the heroicons outline set.
  The view-mode pickers use it for "Table", so it no longer looks like the
  stacked rows that Group by draws.
-->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    data-slot="icon"
    data-icon="table-grid"
  >
    <rect x="3.5" y="4.5" width="17" height="15" rx="2" />
    <path d="M3.5 9.5h17M9.5 9.5v10M15 9.5v10" />
  </svg>
</template>
